import { inject, Injectable } from '@angular/core';
import { LoaderFullScreenService } from '@vueling-ng/vy-ds/src/lib/components/globals/loaders/loader-full-screen';
import { AccountManagerResourcesService } from 'app/services/api-services/accountManager/accountManager.resources';
import { SessionOidcService } from 'app/services/external/auth-oidc/session-oidc.service';
import { UmbracoService } from 'app/services/external/umbraco/umbraco.service';
import { StaticsService } from 'app/services/internal/static/statics.service';
import { ImageLayoutError } from 'app/shared/state/models/app-state.model';
import { catchError, forkJoin, Observable, of, switchMap, take } from 'rxjs';
import { loaderPrimaryConfig } from '../model/languages-config';

@Injectable({
  providedIn: 'root'
})
export class StartConfigService {
  private readonly _accountManagerResourcesService = inject(AccountManagerResourcesService);
  private readonly _staticsService = inject(StaticsService);
  private readonly _umbracoService = inject(UmbracoService);
  private readonly _loaderService = inject(LoaderFullScreenService);
  private readonly _sessionOidcService = inject(SessionOidcService);

  public initializeConfig(): Observable<boolean> {
    this._loaderService.show(loaderPrimaryConfig);
    return forkJoin({
      userInfo: this._accountManagerResourcesService.getAccountInfo().pipe(take(1)),
      statics: this._staticsService.initialize().pipe(
        take(1),
        catchError(() => of({ stations: [], countries: [] }))
      ),
      umbraco: this._umbracoService.initialize().pipe(
        take(1),
        catchError(() => of({ imageLayout: ImageLayoutError, alerts: undefined }))
      )
    }).pipe(
      switchMap(({ userInfo, statics, umbraco }) => {
        this._sessionOidcService.updateState(
          statics.countries,
          statics.stations,
          umbraco.imageLayout,
          umbraco.alerts ?? [],
          userInfo
        );
        this._sessionOidcService.updateCurrentSession(userInfo);
        this._loaderService.hide();
        return of(true);
      }),
      catchError(() => {
        this._loaderService.hide();
        this._sessionOidcService.updateState([], [], ImageLayoutError, []);
        return of(false);
      })
    );
  }
}
